import { Type } from 'class-transformer';
import {
  IsArray,
  IsBoolean,
  IsDateString,
  IsIn,
  IsNotEmpty,
  IsOptional,
  IsString,
  IsUUID,
  ValidateNested,
} from 'class-validator';

import {
  AccountItem,
  Category,
  ContentItem,
  EntityReactions,
  FeedNewsUserActions,
  NewsActivityInfo,
  SocialUser,
} from '@app/gen/favorites';

export class FavoritesFeedNewsType {
  @IsIn(['news'])
  @IsString()
  @IsNotEmpty()
  type: 'news';

  @IsUUID()
  @IsNotEmpty()
  id: string;

  @ValidateNested()
  @Type(() => AccountItem)
  @IsNotEmpty()
  account: AccountItem;

  @IsDateString()
  @IsNotEmpty()
  publishedAt: string;

  @IsString()
  @IsNotEmpty()
  title: string;

  @IsString()
  @IsNotEmpty()
  announcement: string;

  @IsUUID()
  @IsNotEmpty()
  coverAttId: string;

  @ValidateNested()
  @Type(() => Category)
  @IsNotEmpty()
  category: Category;

  @IsString({ each: true })
  @IsArray()
  @IsNotEmpty()
  tags: string[];

  @ValidateNested()
  @Type(() => ContentItem)
  @IsNotEmpty()
  content: ContentItem;

  @ValidateNested()
  @Type(() => SocialUser)
  @IsOptional()
  author?: SocialUser;

  @ValidateNested()
  @Type(() => NewsActivityInfo)
  @IsNotEmpty()
  activityInfo: NewsActivityInfo;

  @IsBoolean()
  @IsNotEmpty()
  isImportant: boolean;

  @IsBoolean()
  @IsNotEmpty()
  commentsEnabled: boolean;

  @IsBoolean()
  @IsNotEmpty()
  reactionsEnabled: boolean;

  @ValidateNested()
  @Type(() => EntityReactions)
  @IsOptional()
  reactions?: EntityReactions;

  @IsBoolean()
  @IsOptional()
  isPinnedInFeed?: boolean;

  @ValidateNested()
  @Type(() => FeedNewsUserActions)
  @IsOptional()
  actions?: FeedNewsUserActions;

  @IsBoolean()
  @IsNotEmpty()
  inFavorites: boolean;
}
